import {
  useObjectApi,
  ObjectApiOptions,
  ObjectApiResult,
} from '~/libs/api-hooks/architect';

interface Me {
  analyticsId: string;
  avatarUrl: string;
  name: string;
  login: string;
  selectedEmail?: string | null;
  identities: Identities;
  privacyOptout: boolean;
  followedProjects: FollowedProject[];
  webUiPipelinesFirstOptIn: boolean;
  webUiPipelinesOptout?: string | null;
  numProjectsFollowed: number;
  signInCount: number;
  createdAt: string;
  inBetaProgram: boolean | string;
  admin?: string | null;
  enrolledBetas: Array<any>;
  basicEmailPrefs: string;
  pusherId: string;
  emailAuthentication?: EmailAuthentication | null;
}

interface Identity {
  login: string;
  type: string;
  avatarUrl?: string | null;
}

interface EmailAuthentication {
  login: string;
  emailVerified: boolean;
}

interface Identities {
  [type: string]: Identity;
}

interface FollowedProject {
  name: string;
  id: string;
  slug: string;
}

interface UseMeProps {
  reactQueryOptions?: ObjectApiOptions<Me>;
}

/**
 * API hook to handle fetch requests to `api/private/me`
 * @endpoint `/api/private/me`
 * @service circle-www-api (TBC)
 */

const useMe = ({ reactQueryOptions }: UseMeProps = {}): ObjectApiResult<Me> => {
  const pathname = '/api/private/me';
  const cacheKey = ['private', 'me'];

  return useObjectApi<Me>({
    pathname,
    cacheKey,
    reactQueryOptions,
    includeApiKeyWhenAvailable: false,
  });
};

export default useMe;
